import type { Policy } from '@/permissions/types';

const MANAGER_PROFILES = ['COORDENADOR_ESCOLA', 'COORDENADOR_TURMA', 'COORDENADOR_SAAS', 'ADMIN', 'SUPER_ADMIN'];

export const essaysPolicies: Policy[] = [
  {
    name: 'view:essays',
    evaluate: ({ user }) => [...MANAGER_PROFILES, 'ALUNO'].includes(user.perfil),
  },
  {
    // Students get their own listing endpoint (no school selector, CONCLUIDA status).
    name: 'view:student_essays',
    evaluate: ({ user }) => user.perfil === 'ALUNO',
  },
];
